import { render, staticRenderFns } from "./ModifyDeliver.vue?vue&type=template&id=d0a3f37e&scoped=true&"
import script from "./ModifyDeliver.vue?vue&type=script&lang=js&"
export * from "./ModifyDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3f37e",
  null
  
)

export default component.exports